import React, {useContext} from 'react'

import {
    StyledMessageContainer,
    StyledName,
    StyledSpeechBubble,
    StyledSpeechBubbleContainer,
} from './styles'
import ActionMessage from './ActionMessage'
import ComposeMessage from './ComposeMessage'
import {EmbedContext} from 'components/EmbedContext'
import {NinchatMessageTypes} from 'api/types/messages'
import {UIMessageProps} from '../types'
import UserAvatar from 'components/Avatar/UserAvatar'
import {useUiState} from 'hooks/state'

// UI Compose and action messages that user can interact with
const UIMessage = ({
    channelId,
    iconUrl,
    isLast,
    isMe,
    isRepeated,
    message,
    time,
    rights,
}: UIMessageProps) => {
    const ui = useUiState()
    const embed = useContext(EmbedContext)
    const isEmbedQueueChannel = embed?.variant === 'queue' || embed?.variant === 'channel'

    // eslint-disable-next-line no-extra-parens
    const showAvatar = !isEmbedQueueChannel || (isEmbedQueueChannel && (embed?.messageAvatars === 'all' || (embed?.messageAvatars === 'agentsOnly' && !isMe)))
    const name = message.message_user_name

    return (
        <StyledMessageContainer hidden={message.message_hidden} isCompose={true} me={isMe} repeated={isRepeated}>
            {!isRepeated && showAvatar ?
                <UserAvatar
                    name={name}
                    size={ui?.chat_density === 'compact' ? 'small' : undefined}
                    src={iconUrl}
                />
                : null}
            <StyledSpeechBubbleContainer me={isMe} repeated={!!(isRepeated && showAvatar)}>
                {!isRepeated && <StyledName isEmbedQueueChannel={isEmbedQueueChannel} me={isMe} rights={rights}>{name}</StyledName>}
                {message.message_type === NinchatMessageTypes.NinchatUIComposeMessage &&
                    <ComposeMessage channelId={channelId} isLast={isLast} message={message} />}
                {message.message_type === NinchatMessageTypes.NinchatUIActionMessage && (
                    <StyledSpeechBubble isEmbedQueueChannel={isEmbedQueueChannel} me={isMe} repeated={isRepeated} rights={rights}>
                        <ActionMessage message={message} time={time} />
                    </StyledSpeechBubble>
                )}
            </StyledSpeechBubbleContainer>
        </StyledMessageContainer>
    )
}

export default UIMessage
